module.exports = __webpack_public_path__ + "static/media/IIC1.76ff9c4c.jpg";